import { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import { getOneNewsItemPage } from "../../api/api";
import { ImageData } from "../../types/news"; // Assuming you have these types defined
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<{ content: string }> = ({ content }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ href, children }) => {
          console.log("Processing link:", href); // Debugging

          if (href?.endsWith(".mp4")) {
            return (
              <center>
              <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                <video controls width="600" style={{ borderRadius: "8px", display: "block" }}>
                  <source src={href} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              </center>
            );
          }

          return (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          );
        },
      }}
    >
      {content}
    </ReactMarkdown>
  );
};


const ProjectNewsPage = () => {
  let { id } = useParams();

  const { i18n } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    "newsData",
    () => getOneNewsItemPage({ id: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  if (isLoading || !data) return <div>Loading...</div>;
  if (error) return <div>Error loading news item.</div>;

  const newsItem = data.data;

  console.log(newsItem);



  return (
    <InnerPageLayout>
      <>
      <Helmet>
        <title>{newsItem.Title}</title>
        <meta name="description" content={newsItem.SubTitle} />
      </Helmet>
      <Container>
        <Row>
          <Col md={12}>
            <div>
              <h1>{newsItem.attributes.Title}</h1>
              <h4>{newsItem.attributes.SubTitle}</h4>
              <MarkdownRenderer content={newsItem.attributes.Content} />





              <div style={{ height: '30px', width: '100%' }}></div>
            </div>
            {newsItem.attributes.Images.data.map((image: ImageData, index: number) => (
              <img
                key={index}
                src={`${process.env.REACT_APP_CMS}${image.attributes.url}`}
                style={{ width: '100%', marginBottom: '50px' }}
                alt={newsItem.attributes.Title}
              />
            ))}
          </Col>
         
        </Row>
      </Container>
      </>
    </InnerPageLayout>
  );
};

export default ProjectNewsPage;
